import React from 'react';
import { Plan } from '@teetsh/app/src/types/plan';
import _orderBy from 'lodash-es/orderBy';
import { useTranslation } from 'react-i18next';
import { QuantitySelector } from '@teetsh/app/src/components/Form/NumberInput/QuantitySelector';
import { Cart } from 'containers/Billing/types';
import { Plans as PlansWithoutControls } from 'containers/Pricing/ChoosePlanPage/Plans';

interface Props {
  cart: Cart;
  onChange: (v: Cart) => void;
  plans: Plan[];
  minQuantity?: number;
}

export function Plans(props: Props) {
  const { cart, onChange, plans } = props;
  const { t } = useTranslation(['userSettings', 'common']);
  const sortedPlans = _orderBy(plans, 'priceYearly', ['asc']);

  return (
    <PlansWithoutControls
      renderControls={({ tier }) => (
        <QuantitySelector
          label={t('userSettings:schoolSubscription.quantity')}
          value={cart[`${tier.id}Quantity`]}
          onChange={v => onChange({ ...cart, [`${tier.id}Quantity`]: v })}
        />
      )}
      paidRecurrence="YEARLY"
      shownRecurrence="YEARLY"
      currentPlan={''}
      plans={sortedPlans}
    />
  );
}
